export default __webpack_public_path__ + "static/media/medium-coins.10a0ebff.png";